import type { CarrierPublicSettings } from '@fv/models'

import { staticQueryOptions } from '@/hooks/useStaticDataQuery'
import { shipperFetch } from '@/utils/shipperFetch'

import { useStaticDataQuery } from './useStaticDataQuery'

export const carrierPublicSettingsKeys = {
  all: ['carrier-public-settings'] as const,
  carrier: (carrierId?: string) =>
    [...carrierPublicSettingsKeys.all, carrierId] as const,
}

async function fetchCarrierPublicSettings(
  carrierId: string,
): Promise<CarrierPublicSettings> {
  return shipperFetch<CarrierPublicSettings>(
    `/carrier-public-settings/${carrierId}`,
  )
}

export function carrierPublicSettingsQueryOptions(carrierId: string) {
  return {
    ...staticQueryOptions,
    queryKey: carrierPublicSettingsKeys.carrier(carrierId),
    queryFn: () => fetchCarrierPublicSettings(carrierId),
    retry: false,
  }
}

export function useCarrierPublicSettings(carrierId?: string) {
  const carrierSettingsQuery = useStaticDataQuery(
    carrierPublicSettingsKeys.carrier(carrierId),
    () => fetchCarrierPublicSettings(carrierId!),
    { enabled: Boolean(carrierId) },
  )

  const { isFetching, data } = carrierSettingsQuery
  return { isFetching, carrierPublicSettings: data }
}
